// extracted by mini-css-extract-plugin
export default {"contactSection":"Contact_contactSection__Cy68R","socialMediaIcons":"Contact_socialMediaIcons__9FSqA"};